module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/util@0.11.1/~/util/support/isBufferBrowser.js
// module id = I0Ip
// module chunks = 5